import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'
import VehicleDisplayName from 'components/Common/VehicleDisplayName/VehicleDisplayName'
import React from 'react'
import { confirmAlert } from 'react-confirm-alert'

type CancelJobProps = {
  action: any
  job: any
}

const handleCancelJob = async ({ action, job }: CancelJobProps) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      console.log('cancel job: ', job)
      return (
        <Dialog
          open={true}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={(theme) => ({
              backgroundColor: '#ee000e',
              color: theme.palette.info.contrastText,
              fontSize: 'var(--fs-24, 1.5rem)',
            })}
          >
            Cancellation Confirmation
          </DialogTitle>
          <DialogContent sx={{ marginTop: '20px' }}>
            <Grid>
              <ListItem alignItems="flex-start">
                <Box
                  component="img"
                  src={job.vehicleDetails.icon}
                  sx={{ width: '15%' }}
                />
                <ListItemText
                  sx={{ marginLeft: '30px' }}
                  primary={VehicleDisplayName({
                    vehicleDetails: job.vehicleDetails,
                  })}
                  secondary={
                    <React.Fragment>{job.jobReference}</React.Fragment>
                  }
                />
                <ListItemText
                  sx={{ marginLeft: '70px' }}
                  primary={`Cancellation Policy`}
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: 'inline' }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {job.cancellationPolicy}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
            </Grid>
            <Typography>
              Please confirm that you still want to cancel{' '}
              <b>{job.jobReference}</b>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>No</Button>
            <Button
              color="primary"
              onClick={() => {
                action()
                onClose()
              }}
            >
              Yes, Cancel it!
            </Button>
          </DialogActions>
        </Dialog>
      )
    },
  })
}

export default handleCancelJob
